import { loadMenu } from './menuActions';

export { loadMenu };

export const selectMenu = (state) => state.menu || { loading: false, data: [] };
